// extracted by mini-css-extract-plugin
module.exports = {"body":"Asteroid_body__3y_Ml","type1":"Asteroid_type1__1bmmg","type2":"Asteroid_type2__3GWGL","type3":"Asteroid_type3__3ChCr","type4":"Asteroid_type4__tMcmo"};